import { ILpAdaptersStore, LpIntegrationDirection } from './lpAdapters.interface';

export const lpAdaptersInitialState: ILpAdaptersStore = {
  adapters: [],
};

// Preconfigured demo adapter: CP manages its connection settings itself,
// so the UI must not request the schema or render connection sections for it.
export const DEMO_CBRIDGE_ADAPTER = 'DEMO_CBRIDGE';

export const LP_INTEGRATION_DIRECTION_LABEL_KEY = {
  [LpIntegrationDirection.Inbound]: 'text:entity.liquidityProvider.integrationDirection.value_INBOUND',
  [LpIntegrationDirection.Outbound]: 'text:entity.liquidityProvider.integrationDirection.value_OUTBOUND',
} as const satisfies Record<LpIntegrationDirection, string>;
